import { Injectable } from '@angular/core';
import { AppSettings } from './models/configuration/app-settings';

declare let window: any;

@Injectable()
export class Configuration {
    public appSettings: AppSettings;

    constructor() {
        this.appSettings = <AppSettings>window.configuration;
    }
}


// WEBPACK FOOTER //
// ./src/app/app.config.ts